import styles from './PageEdit.module.css'
import { useState } from 'react'
import SelectImage from './SelectImage'
import ImageGallery from './websiteComponents/ImageGallery'

export default function GalleryEdit({sectionKey, images, updateField}){
    const [imageList, setImageList] = useState(images || [])

    const updateImageList = (imageUrl, index) => {
        const newImageList = [...imageList]
        newImageList[index] = imageUrl
        setImageList(newImageList)
        updateField(sectionKey,'images', newImageList)
    }

    return(
        <div className={styles.pageInfoEdit}>
            <h2>Billede galleri</h2>
            {/* Show the images how they are displayed on the webpage */}
            <ImageGallery images={imageList}/>
            <div className={styles.item}>
                <p>Billede 1</p>
                <SelectImage onSelect={(url) => updateImageList(url, 0)} />
            </div>
            <div className={styles.item}>
                <p>Billede 2</p>
                <SelectImage onSelect={(url) => updateImageList(url, 1)} />
            </div>
            <div className={styles.item}>
                <p>Billede 3</p>
                <SelectImage onSelect={(url) => updateImageList(url, 2)} />
            </div>
        </div>
    )
}